import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

export default function JournalPost() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`, { params: { lang } }).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug, lang]);
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24 text-[#0A1128]/60">…</div>;
  return (
    <article className="max-w-3xl mx-auto px-6 pt-12 pb-32">
      <Link to="/journal" className="overline text-[#D4AF37] link-gold">{lang === "fr" ? "← Journal" : "← Journal"}</Link>
      <h1 className="font-serif font-light text-5xl md:text-6xl text-[#0A1128] mt-8 leading-tight" data-testid="post-title">{post.title}</h1>
      <div className="mt-6 text-sm text-[#0A1128]/60">
        {post.author} · {post.published_at?.slice(0, 10)}
      </div>
      <img src={post.cover} alt={post.title} className="w-full h-[420px] md:h-[520px] object-cover mt-10" />
      <div className="mt-10 font-serif text-xl md:text-2xl leading-relaxed text-[#0A1128]/90 whitespace-pre-line">
        {post.content}
      </div>
    </article>
  );
}
